import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';

import 'bootstrap/dist/css/bootstrap.css';

import Vue3TouchEvents from 'vue3-touch-events';

import VueObserveVisibility from 'vue3-observe-visibility'

const app = createApp(App);
app.use(router);
app.use(VueObserveVisibility);
app.use(Vue3TouchEvents);

app.mount('#app');
